import { render, staticRenderFns } from "./PriceSlabsTabs.vue?vue&type=template&id=3a9af818&scoped=true"
import script from "./PriceSlabsTabs.vue?vue&type=script&lang=js"
export * from "./PriceSlabsTabs.vue?vue&type=script&lang=js"
import style0 from "./PriceSlabsTabs.vue?vue&type=style&index=0&id=3a9af818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9af818",
  null
  
)

export default component.exports